import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/index';
import { urlConstants } from '../../../constants/urlConstants';

export const bulkUpdateApi = createApi({
    reducerPath: 'bulkUpdateApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
        prepareHeaders: (headers) => {
            headers.set("Authorization", `Token ${localStorage.getItem('cw-token')}`);
            return headers;
        },
    }),

    endpoints: (builder) => ({
        bulkUpdateGeneric: builder.mutation<any, { modelName: string, data: any[] }>({
            query: (payload) => ({
                url: urlConstants?.BULK_UPDATE_GENERIC,
                method: 'POST',
                body: payload
            }),
        }),
    }),
});

export const { useBulkUpdateGenericMutation } = bulkUpdateApi;
